export enum PrimarySectionIndent {
  None = 'none',
  External = 'external',
  Internal = 'internal',
  Compact = 'compact',
  Xxl = 'xxl',
}
